/**
 * Single source of truth for brand, contact and SEO data.
 * Change the number or the domain here and the whole site follows.
 */

export const SITE = {
    name: 'Nitin Online Book',
    altName: 'Nitin Online Book',
    domain: 'nitinonlinehub.online',
    url: 'https://nitinonlinehub.online',
    logo: 'https://nitinonlinehub.online/assets/images/logo.png',
    locale: 'en_IN',
    tagline: "India's Most Trusted Online Gaming Hub",
};

export const WHATSAPP_NUMBER = '918736849808';
export const WHATSAPP_DISPLAY = '+918736849808';
export const TELEGRAM_URL = 'https://t.me/+kMlveMEzBI5jNzk1';

export const SOCIALS = {
    instagram: 'https://www.instagram.com/nitinnonlinehubofficial?stkn=djNyeXIyM2NobWFn',
    telegramChannel: 'https://t.me/+kMlveMEzBI5jNzk1',
    telegramGroup: 'https://t.me/+kMlveMEzBI5jNzk1',
    email: 'support@nitinnonlinehub.com',
    city: 'Mumbai, India',
};

/** Ready-made openers so every CTA starts a real conversation. */
export const WA_MESSAGES = {
    general: "Hi Nitin Online Book team! I'd like to know more about Nitin Online Book — login, sign up and app download. Please guide me.",
    newId: "Hi! I want to create my gaming ID on Nitin Online Book. Please share the Nitin online book sign up steps and welcome bonus details.",
    login: "Hi! I need help with my Nitin online book login. Can you assist me right now?",
    appDownload: "Hi! Please send me the official Nitin online book app download link for Android / iOS.",
    withdrawal: "Hi! I'd like to understand deposits and the 5-minute instant withdrawal process on Nitin Online Book.",
    vip: "Hi! I'm interested in the VIP desk at Nitin Online Book — higher limits, cashback and a dedicated manager.",
    strategy: "Hi! I saw the winner stories on Nitin Online Book. Please share game strategies and expert guidance to get started.",
    game: (name) =>
        `Hi! I'd like to play ${name} on Nitin Online Book. Please help me with my gaming ID, table limits and bonus.`,
    support: "Hi! I need 24/7 support from the Nitin Online Book team. Here is my question:",
};

/** Builds a wa.me deep link with a pre-filled message. */
export const waLink = (message = WA_MESSAGES.general) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

/** Opens WhatsApp in a new tab. */
export const openWhatsApp = (message = WA_MESSAGES.general) => {
    window.open(waLink(message), '_blank', 'noopener,noreferrer');
};

export const openTelegram = () => {
    window.open(TELEGRAM_URL, '_blank', 'noopener,noreferrer');
};

export const ROUTES = {
    home: '/homepage-royal-welcome-hub',
    games: '/games-showcase-gaming-palace',
    about: '/about-dynasty-brand-heritage',
    winners: '/success-stories-gallery-winner-showcase',
    contact: '/vip-contact-suite-whats-app-hub',
};

export default SITE;